import { useWindowWidth } from './useWindowWidth';

type Breakpoint<T> = {
  maxWidth: number;
  value: T;
};

export const useBreakpointValue = <T>(breakpoints: Breakpoint<T>[], defaultValue: T): undefined | T => {
  const windowWidth = useWindowWidth();

  if (windowWidth === undefined) {
    return undefined;
  }

  const sorted = [...breakpoints].sort((a, b) => a.maxWidth - b.maxWidth);
  const match = sorted.find(({ maxWidth }) => windowWidth < maxWidth);
  return match ? match.value : defaultValue;
};
